// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1xusU","label":"Labeled_label___gfY2","divider":"Labeled_divider__RSgQy"};